import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';
import { SubscriptionTypes } from '@Enums';
import { sortSubscriptions } from '@Helpers/utilities-ryan';
import { isArray, isNumber } from 'lodash-es';
export default class GetUserSubscriptions extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'subscriptions-getUserSubscriptionsTemp',
      payload: { ...this._payload },
    });
  }
  
  onSuccess(data) {
    // Check if get subs is called for another user (admin usage)
    if(this._payload.user_id && this._payload.user_id !== this._state.user.id) {
      super.onSuccess(...arguments);
      return;
    }

    if( data && isArray(data) ) {
      data.sort(sortSubscriptions)
    }

    let hasPlaylistCMSAccess = false;
    let hasPlatformAccessSub = false;
    let hasAllAccessSub = false;
    let hasAllAccessExpired = false;
    let allAccessExpiryDate = null;
    let hasBootcampAccessSub = false;
    let hasBootcampAccessExpired = false;
    let bootCampExpiryDate = null;
    let profileAllowance = 0;
    let accessTeamId = "";

    if (data) {
      data.forEach((sub) => {
        let isExpired = false;
        if(isNumber(sub.expiry_date) 
        && sub.expiry_date !== 0 
        && sub.expiry_date < new Date().getTime()) {
          isExpired = true;
        }

        if (sub.type === SubscriptionTypes.PLATFORM_ACCESS) {
          // If platformAccessSub is not already true from a previous sub check, check if the current sub is expired before defaulting to true
          // hasPlatformAccessSub = hasPlatformAccessSub === true ? true : (isExpired === true ? false : true);
          hasPlatformAccessSub = true;
          if (sub.id === 'BOOTCAMP_ACCESS') {
            hasBootcampAccessSub = true;
            hasBootcampAccessExpired = isExpired;
            hasBootcampAccessExpired = sub.expiry_date || null;
          }
          if (sub.id === 'FULL_ACCESS') {
            hasAllAccessSub = true;
            hasAllAccessExpired = isExpired;
            allAccessExpiryDate = sub.expiry_date || null;
            if( sub.provider ) {
              if( sub.provider === "USER" && sub.profile_allowance ) {
                profileAllowance += sub.profile_allowance;
              }
              else if( sub.provider === "TEAM" ) {
                accessTeamId = sub.provider_id;
              }
            }
          }
        }
        if(sub.type === SubscriptionTypes.FEATURE_SWITCH) {
          if(sub.id === 'PLAYLIST_CMS_FEATURE') hasPlaylistCMSAccess = true;
        }
      });
    }

    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        user: {
          profileAllowance: profileAllowance,
          accessTeamId: accessTeamId
        },
      },
    });

    if (hasPlatformAccessSub) {
      this._state.auth.events.subscriptionAccessGranted.emit(data);
    }
    this._state.auth.events.subscriptionsResolved.emit(data, {
      profileAllowance: profileAllowance,
      accessTeamId: accessTeamId
    });
    super.onSuccess(...arguments);
  }
}
